export default (name: string): boolean => {
    if (typeof (window) !== "undefined" && typeof (window.document) !== "undefined") {
        const isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(" OPR/") >= 0;
        const isFirefox = typeof InstallTrigger !== "undefined";
        const isSafari = (/constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window["safari"] || (typeof safari !== "undefined" && window["safari"].pushNotification)) || /iphone|ipod|ipad|safari/.test(window.navigator?.userAgent.toLowerCase()));
        const isIE = /*@cc_on!@*/false || !!document.documentMode;
        const isEdge = !isIE && !!window.StyleMedia;
        const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
        const isEdgeChromium = isChrome && (navigator.userAgent.indexOf("Edg") !== -1);

        if (isOpera && name.toLowerCase() === "opera")
            return true;

        if (isFirefox && name.toLowerCase() === "firefox")
            return true;

        if (isSafari && name.toLowerCase() === "safari")
            return true;

        if (isIE && name.toLowerCase() === "ie")
            return true;

        if (isChrome && name.toLowerCase() === "chromium")
            return true;

        if (isEdge && name.toLowerCase() === "edge")
            return true;

        if (isEdgeChromium && name.toLowerCase() === "chromium")
            return true;
    }

    return false;
};
